import React from 'react';
import './Projects.css';
import { Col, Container, Row, Card, Button } from 'react-bootstrap';
import data from '../../FakeData/ProjectData/BlogsData/ProjectData';
import Zoom from 'react-reveal/Zoom';

const Projects = () => {
  return (
    <>
      <Container id="projectsPage" className="text-center">
        <h1 className="my-3 text-center sectionTitle">Projects</h1>
        <Row className="mt-3 pb-5 d-flex justify-content-center customSection">
          {
            data.map(item =>
              <Zoom duration={2000}>
                <Col
                  key={item.id}
                  md={4}
                  lg={4}
                  className="mb-3 mt-5 mr-5 pt-3 pl-3 text-dark animated">
                  <Card
                    className="text-center cardAnimated"
                    style={{ width: '16rem' }}>
                    <Card.Img
                      variant="top"
                      src={item.image}
                      alt="" />
                    <Card.Body>
                      <Card.Title
                        className="projectTitle">
                        {item.name}
                      </Card.Title>
                      <Card.Text>
                        {item.description}
                      </Card.Text>
                      <div className="d-flex justify-content-between">
                        <a
                          href={item.github}
                          target="_blank"
                          rel="noreferrer">
                          <Button variant="outline-warning">
                            Github
                          </Button>
                        </a>
                        <a href={item.website}
                          target="_blank"
                          rel="noreferrer">
                          <Button
                            variant="outline-warning">
                            Live
                          </Button>
                        </a>
                      </div>

                    </Card.Body>
                  </Card>
                </Col>
              </Zoom>
            )
          }

        </Row>
        <a
          href="https://github.com/reya3183?tab=repositories" target="_blank"
          rel="noreferrer">
          <Button variant="outline-light">
            Explore More Projects
        </Button>
        </a>
      </Container>

    </>
  );
};

export default Projects;